import React from 'react';
import { ArrowLink } from '../../../../../ui';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

export const BusWaitTimesLink = () => {
	const { t } = useTranslation();
	const url = useUrlForPageId(PassengersPageId.BusWaitTimes);
	const linkText = t('flight_details_bus_waiting_times_link');

	return (
		<ArrowLink aria-label="bus-wait-time" href={url}>
			{linkText}
		</ArrowLink>
	);
};
